import * as React from 'react';
import { ViewStateChangeInfo } from 'react-map-gl';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    ApiBasedataList,
    ApiCourseProvidersLoadmine,
    ApiCourseProvidersRemoveLocation,
    ApiCourseProvidersSaveLocation,
    BasedataParams,
    CoursesProviderLoadMineResult,
    CoursesProviderRemoveLocationResult,
    CoursesProviderSaveLocationResult,
    Image,
    Location,
    ServerResponse,
    UploadImage,
    ValidationError,
} from '../../api';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import CPLocationList from '../../components/cpLocationList/CPLocationList';
import Footer from '../../components/footer/Footer';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import { IEmptyProps, MAPBOX_ACCESS_TOKEN } from '../../constants';

interface IState {
    currentEditLocationID: number | undefined;
    currentDeleteLocationID: number | undefined;
    editValue: Location;
    errors: string[];
    geoAccuracyError: boolean;
    geoValidationErrors: GeoValidationError;
    loading: boolean;
    locationList: Location[];
    locationPossibleParticularities: BasedataParams;
    matchList: string[];
    modalOpen: boolean;
    modalState: SelectionMethod;
    newLocation: Location;
    serverResponse?: ServerResponse;
    uploadImages: UploadImage[];
    zoomEditValue: number;
    zoomLocation: number;
}

export interface GeoValidationError {
    city?: boolean;
    country?: boolean;
    street?: boolean;
    zip?: boolean;
}

export enum SelectionMethod {
    Delete,
    Edit,
    None,
}

export default class CPAllLocations extends React.Component<IEmptyProps, IState> {
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            currentDeleteLocationID: undefined,
            currentEditLocationID: undefined,
            editValue: {
                City: '',
                Country: '',
                ID: 0,
                Images: [],
                Lat: 0,
                Long: 0,
                Name: '',
                Particulatities: [],
                Street: '',
                Telephone: '',
                Zip: '',
            },
            errors: [],
            geoAccuracyError: false,
            geoValidationErrors: {},
            loading: true,
            locationList: [],
            locationPossibleParticularities: {
                Data: [],
                Key: '',
                Name: '',
            },
            matchList: [],
            modalOpen: false,
            modalState: SelectionMethod.None,
            newLocation: {
                City: '',
                Country: '',
                ID: 0,
                Images: [],
                Lat: 0,
                Long: 0,
                Name: '',
                Particulatities: [],
                Street: '',
                Telephone: '',
                Zip: '',
            },
            serverResponse: undefined,
            uploadImages: [],
            zoomEditValue: 14,
            zoomLocation: 14,
        };
    }

    public componentDidMount() {
        ApiCourseProvidersLoadmine((cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
            if (cpsr.OK && cpsr.Data) {
                this.setState(
                    {
                        loading: false,
                        locationList: cpsr.Data.CourseProviderEdit.Locations,
                    },
                    () => {
                        if (this.state.locationList.length === 0) {
                            const locationList: Location[] = [];
                            locationList.push(this.state.newLocation);
                            this.setState(
                                {
                                    locationList,
                                },
                                () => {
                                    this.selectEntry(this.state.locationList[0].ID, SelectionMethod.Edit);
                                }
                            );
                        }
                        ApiBasedataList((sr) => {
                            if (sr.Data !== undefined) {
                                sr.Data.Basedata.map((data: BasedataParams) => {
                                    if (data.Key === 'particularities') {
                                        this.setState({
                                            locationPossibleParticularities: data,
                                        });
                                    }
                                });
                            } else {
                                this.setState({ serverResponse: sr });
                            }
                        });
                    }
                );
            } else {
                this.setState({
                    serverResponse: cpsr,
                });
            }
        });
    }

    public render() {
        return (
            <NetworkOverlay
                loading={this.state.loading}
                serverResponse={this.state.serverResponse}
                forceLoading={this.state.loading}
            >
                <CPHeaderLoggedIn />
                <CPLocationList
                    addNewRecord={this.addNewRecord}
                    addUploadImage={this.addUploadImage}
                    cancelHandler={this.cancelHandler}
                    changeHandler={this.changeHandler}
                    deleteImageHandler={this.deleteImageHandler}
                    deleteUploadImage={this.deleteUploadImage}
                    editItemID={this.state.currentEditLocationID}
                    editValue={this.state.editValue}
                    errorClass={this.errorClass}
                    errors={this.state.errors}
                    geoAccuracyError={this.state.geoAccuracyError}
                    geoCalculate={this.geoCalculate}
                    geoValidationErrors={this.state.geoValidationErrors}
                    serverResponse={this.state.serverResponse}
                    locations={this.state.locationList}
                    locationPossibleParticularities={this.state.locationPossibleParticularities}
                    saveHandler={this.saveHandler}
                    selectEntry={this.selectEntry}
                    toggleLocationParticularity={this.toggleLocationParticularity}
                    updateViewport={this.updateViewport}
                    uploadImages={this.state.uploadImages}
                    zoomEditValue={this.state.zoomEditValue}
                    zoomLocation={this.state.zoomLocation}
                />
                <Modal isOpen={this.state.modalOpen}>
                    <ModalHeader>{TR.cPAllLocations_delete_entry}</ModalHeader>
                    <ModalBody>{TR.cPAllLocations_really_delete}</ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.toggleModal(SelectionMethod.None)}>
                            {TR.cPAllLocations_cancel}
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.deleteHandler(this.state.currentDeleteLocationID!);
                            }}
                        >
                            {TR.cPAllLocations_delete}
                        </Button>{' '}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={!!this.state.matchList && this.state.matchList.length > 0}>
                    <ModalHeader>{TR.cPAllLocations_cannot_delete}</ModalHeader>
                    <ModalBody>
                        <div className="col-md-12">{TR.cPAllLocations_cannot_delete_location}</div>
                        <br />
                        {!!this.state.matchList &&
                            this.state.matchList.map((entry, i) => (
                                <div key={i} className="col-md-12">
                                    <label style={{ color: 'green' }}>{'->' + entry}</label>
                                </div>
                            ))}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({ matchList: [] });
                            }}
                        >
                            {TR.cPAllLocations_ok}
                        </Button>
                    </ModalFooter>
                </Modal>
                <Footer />
            </NetworkOverlay>
        );
    }

    private addNewRecord = () => {
        const locationList: Location[] = this.state.locationList;
        const newLocation: Location = this.state.newLocation;

        locationList.push(newLocation);

        this.setState({ locationList }, () => this.selectEntry(0, SelectionMethod.Edit));
    };

    private cancelHandler = () => {
        const locationToChange: Location = this.getLocationById(this.state.currentEditLocationID!);
        if (
            locationToChange.Name === '' ||
            locationToChange.Street === '' ||
            locationToChange.Zip === '' ||
            locationToChange.City === '' ||
            locationToChange.Country === ''
        ) {
            if (this.state.locationList.length > 1) {
                const locationList: Location[] = this.state.locationList;
                locationList.pop();
                this.setState({
                    uploadImages: [],
                    locationList,
                });
            } else {
                return;
            }
        }
        this.setState({
            uploadImages: [],
            currentEditLocationID: undefined,
            errors: [],
            geoValidationErrors: {},
            serverResponse: undefined,
        });
    };

    private changeHandler = (value: string, field: string) => {
        const editValue: Location = { ...this.state.editValue };
        // @ts-ignore
        editValue[field] = value;
        this.setState({
            editValue,
            errors: [],
            geoValidationErrors: {},
            serverResponse: undefined,
        });
    };

    private deleteHandler = (entryId: number) => {
        this.setState({
            loading: true,
            modalOpen: false,
            modalState: SelectionMethod.None,
        });
        ApiCourseProvidersRemoveLocation(
            { EntryID: entryId },
            (cpsr: ServerResponse & { Data?: CoursesProviderRemoveLocationResult }) => {
                if (cpsr.OK && cpsr.Data) {
                    this.setState(
                        {
                            loading: false,
                            locationList: cpsr.Data.Locations,
                            matchList: cpsr.Data.MatchedList,
                        },
                        () => {
                            if (this.state.locationList.length === 0) {
                                const locationList: Location[] = [];
                                locationList.push(this.state.newLocation);
                                this.setState(
                                    {
                                        locationList,
                                    },
                                    () => {
                                        this.selectEntry(this.state.locationList[0].ID, SelectionMethod.Edit);
                                    }
                                );
                            }
                        }
                    );
                } else {
                    this.setState({
                        serverResponse: cpsr,
                    });
                }
            }
        );
    };

    private errorClass = (fieldname: string) => {
        if (this.state.serverResponse && this.state.serverResponse.Errors) {
            const errorsForThisField = this.state.serverResponse.Errors.filter(
                (error: ValidationError) => error.Parameter.toLowerCase() === fieldname.toLowerCase()
            );
            return errorsForThisField.length > 0 ? 'error' : '';
        }
        return '';
    };

    private geoCalculate = (callback?: () => void) => {
        if (this.geoFieldsValidate()) {
            const originalLocation: Location = this.getLocationById(this.state.currentEditLocationID!);
            if (
                originalLocation.City !== this.state.editValue.City ||
                originalLocation.Street !== this.state.editValue.Street ||
                originalLocation.Country !== this.state.editValue.Country ||
                originalLocation.Zip !== this.state.editValue.Zip
            ) {
                this.getNewMapLocation(callback);
            } else {
                if (!!callback) {
                    callback();
                }
            }
        } else {
            this.setState({ loading: false });
        }
    };

    private geoFieldsValidate = () => {
        const geoValidationErrors: GeoValidationError = {};
        if (this.state.editValue.Street.length < 3) {
            geoValidationErrors.street = true;
        }
        if (this.state.editValue.City.length < 3) {
            geoValidationErrors.city = true;
        }
        if (this.state.editValue.Country.length < 3) {
            geoValidationErrors.country = true;
        }
        this.setState({
            geoValidationErrors,
        });
        if (Object.keys(geoValidationErrors).length === 0) {
            return true;
        }
        return false;
    };

    private getLocationById = (entryId: number) => {
        let location: Location = this.state.newLocation;
        for (let i = 0; i < this.state.locationList.length; i++) {
            if (this.state.locationList[i].ID === entryId) {
                location = { ...this.state.locationList[i] };
                break;
            }
        }
        return location;
    };

    private getNewMapLocation = (callback?: () => void) => {
        fetch(
            'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                this.state.editValue.Street.replace('/', ' ') +
                ' ' +
                this.state.editValue.Zip +
                ' ' +
                this.state.editValue.City +
                ' ' +
                this.state.editValue.Country +
                '.json?language=DE&fuzzyMatch&access_token=' +
                MAPBOX_ACCESS_TOKEN,
            { method: 'GET' }
        )
            .then((resp) => resp.json())
            .then((data) => {
                if (data.features && data.features.length > 0) {
                    const editValue = { ...this.state.editValue };
                    editValue.Lat = data.features[0].center[1];
                    editValue.Long = data.features[0].center[0];
                    this.setState((prevState: IState): IState => {
                        return { ...prevState, editValue, geoAccuracyError: false, loading: false };
                    });
                    if (!!callback) {
                        callback();
                    }
                } else {
                    this.setState((prevState: IState): IState => {
                        return { ...prevState, geoAccuracyError: true, loading: false };
                    });
                }
            });
    };

    private saveHandler = () => {
        this.setState(
            {
                loading: true,
            },
            () => {
                this.geoCalculate(this.saveLocation);
            }
        );
    };

    private saveLocation = () => {
        ApiCourseProvidersSaveLocation(
            {
                City: this.state.editValue.City,
                Country: this.state.editValue.Country,
                ID: this.state.editValue.ID,
                Images: this.state.editValue.Images,
                Lat: this.state.editValue.Lat,
                Long: this.state.editValue.Long,
                Name: this.state.editValue.Name,
                Particulatities: this.state.editValue.Particulatities,
                Street: this.state.editValue.Street,
                Telephone: this.state.editValue.Telephone,
                Zip: this.state.editValue.Zip,
                UploadImages: this.state.uploadImages,
            },
            (sr: ServerResponse & { Data?: CoursesProviderSaveLocationResult }) => {
                if (sr.OK && sr.Data) {
                    this.setState({
                        currentEditLocationID: undefined,
                        editValue: this.state.newLocation,
                        geoAccuracyError: false,
                        geoValidationErrors: {},
                        loading: false,
                        locationList: sr.Data.Locations,
                        serverResponse: undefined,
                        uploadImages: [],
                    });
                } else if (!sr.OK && sr.Error === 'validation_error') {
                    this.setState({
                        geoAccuracyError: false,
                        geoValidationErrors: {},
                        loading: false,
                        serverResponse: sr,
                    });
                } else {
                    this.setState({
                        geoAccuracyError: false,
                        geoValidationErrors: {},
                        serverResponse: sr,
                    });
                }
            }
        );
    };

    private selectEntry = (entryId: number, selectionMethod: SelectionMethod) => {
        if (selectionMethod === SelectionMethod.Delete) {
            this.setState({ currentDeleteLocationID: entryId, modalOpen: true, modalState: selectionMethod });
        } else if (selectionMethod === SelectionMethod.Edit) {
            this.setState({ currentEditLocationID: entryId, editValue: this.getLocationById(entryId) });
        }
    };

    private toggleLocationParticularity = (locationParticularityId: number) => {
        const location: Location = this.state.editValue;
        if (location.Particulatities.indexOf(locationParticularityId) > -1) {
            location.Particulatities.splice(location.Particulatities.indexOf(locationParticularityId), 1);
        } else {
            location.Particulatities.push(locationParticularityId);
        }
        this.setState({
            editValue: location,
        });
    };

    private toggleModal = (modalState: SelectionMethod) => {
        this.setState({
            modalOpen: !this.state.modalOpen,
            modalState,
        });
    };

    private updateViewport = (info: ViewStateChangeInfo) => {
        this.setState((prevState: IState): IState => {
            return { ...prevState, zoomEditValue: info.viewState.zoom };
        });
    };

    private addUploadImage = (image: UploadImage) => {
        this.setState({ uploadImages: [...this.state.uploadImages, image] });
    };

    private deleteUploadImage = (index: number) => {
        const uploadImages = this.state.uploadImages;
        uploadImages.splice(index, 1);
        this.setState({ uploadImages: [...uploadImages] });
    };

    private deleteImageHandler = (index: number) => {
        const editValue: Location = { ...this.state.editValue };
        const images: Image[] = [...editValue.Images];
        const image = images.splice(index, 1);
        editValue.Images = images;

        this.setState({
            editValue,
            uploadImages: [
                ...this.state.uploadImages,
                {
                    Delete: true,
                    FileName: '',
                    ImageData: '',
                    ID: image[0].ID,
                },
            ],
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/cPAllLocations/CPAllLocations.tsx